<template>
  <div>
    <span v-if="value.task_status === true">
      <v-btn
          class="mx-0"
          width="15px"
          height="15px"
          fab
          dark
          x-small
          color="success"
          @click="goToTask"
      >
        <v-icon dark>mdi-check-circle-outline</v-icon>
      </v-btn>
    </span>
    <span v-else-if="value.task_status === false">
      <v-btn
          class="mx-0"
          width="15px"
          height="15px"
          fab
          dark
          x-small
          color="error"
          @click="goToTask"
      >
        <v-icon dark>mdi-alert-circle-outline</v-icon>
      </v-btn>
    </span>
    <span v-else-if="value.task_id == null">
    </span>
    <span v-else>
      <v-progress-circular color="primary" :size="15" :width="2" indeterminate></v-progress-circular>
    </span>
  </div>
</template>

<script>

export default {
  name: 'BaseTaskProgress',
  props: ['value'],

  data() {
    return {
      taskStatus: null,
    }
  },

  components: {},

  computed: {},

  methods: {
    goToTask() {
      this.$router.push({name: 'BaseTaskView', params: {taskId: this.value.task_id}})
    }
  },

  mounted() {
    // console.log('mounted', this.value)
  },

}
</script>

<style scoped lang="scss">
</style>
